import React, { useEffect, useState, useCallback } from 'react';
import { Table, message as antMessage } from 'antd';
import dayjs from 'dayjs';
import { fetchDebtorsForSetting } from '../../../services/chargesApi';

const DebtorsTab = ({ settingId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!settingId) return;
    setLoading(true);
    try {
      const data = await fetchDebtorsForSetting(settingId);
      setItems(data.debtors || []);
    } catch {
      antMessage.error('Erro ao carregar devedores');
    } finally {
      setLoading(false);
    }
  }, [settingId]);

  useEffect(() => { load(); }, [load]);

  const columns = [
    { title: 'Jogador', dataIndex: 'player_name', width: 200 },
    { title: 'Telefone', dataIndex: 'player_phone', width: 140 },
    {
      title: 'Faturas pendentes',
      dataIndex: 'pending_invoices',
      width: 140,
      align: 'center',
    },
    {
      title: 'Total devido',
      dataIndex: 'total_due',
      width: 130,
      align: 'right',
      render: (v) => `R$ ${(parseFloat(v) || 0).toFixed(2)}`,
    },
    {
      title: 'Fatura mais antiga',
      dataIndex: 'oldest_invoice_at',
      width: 160,
      render: (v) => v ? dayjs(v).format('DD/MM/YYYY HH:mm') : '-',
    },
  ];

  return (
    <Table
      rowKey="player_id"
      loading={loading}
      dataSource={items}
      columns={columns}
      pagination={{ pageSize: 50, showSizeChanger: false }}
      scroll={{ x: 'max-content' }}
      size="small"
    />
  );
};

export default DebtorsTab;
